<template>
  <Layout style="background: #21343b">
    <h2 slot="title" class="text-center" style="color: white">{{ $t('joinWorkspace') }}</h2>
    <p slot="desc" class="desc text-center mb-0">{{ $t('joinWorkspaceDesc') }}</p>
    <v-form
      slot="content"
      ref="requestWsForm"
      class="text-center mt-16 pt-4"
      @submit.prevent="setRequestWs"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col class="pt-0 pb-0 text-left">
            <label for="wsDomain" class="text-left" style="color: white">
              {{ $t('workspaceDomain') }}
            </label>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-text-field
              prefix="www.tape.ooo/"
              outlined
              dense
              dark
              ref="wsDomain"
              id="wsDomain"
              placeholder="myworkspace"
              :rules="[rules.required(wsDomain, 'wsDomain'), rules.min(wsDomain)]"
              hide-details="auto"
              validate-on-blur
              v-model="wsDomain"
              @keyup="
                checkVal(0, $refs.wsDomain.hasError)
                replaceWsDomain()
              "
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0 mt-8">
            <v-btn
              block
              elevation="0"
              height="40"
              :disabled="!isBtnAble || isLoading"
              :loading="isLoading"
              :class="'btn-' + (isBtnAble ? 'able' : 'disable')"
              id="continue"
              @click="setRequestWs"
            >
              {{ $t('continue') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="showMsg">
          <v-col class="pt-0 pb-0 mt-5">
            <v-alert dense outlined :color="'#fff'">
              <span v-html="errorMessage" style="color: white" />
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <loading-dialog :isLoading="isLoading"></loading-dialog>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
import { fill } from 'lodash'
import { isNull } from '@/common/lib/strLib'
import { chkWsDomain } from '@/services/api'
import LoadingDialog from '@/views/modal/LoadingDialog'

export default {
  name: 'JoinWorkspace',
  components: {
    LoadingDialog,
    Layout,
  },
  created() {
    this.valChkArray = fill(Array(1), false)
  },
  data: () => ({
    wsDomain: '',
    valChkArray: [],
    isBtnAble: false,
    isLoading: false,
    showMsg: false,
    errorCode: '',
    errorMessage: '',
  }),
  computed: {
    rules() {
      let vm = this

      return {
        required: (value, type) => !isNull(value) || vm.$t('msgEnter' + type.charAt(0).toUpperCase() + type.slice(1)),
        min: (value) => value.length > 1 || vm.$t('msgWorkspaceNameMinLength'),
      }
    },
  },
  methods: {
    checkVal(index, result) {
      this.valChkArray.splice(index, 1, !result)
      this.isBtnAble = !this.valChkArray.includes(false)
    },
    replaceWsDomain() {
      this.wsDomain = this.wsDomain.replace(/[^a-z0-9-]/gi, '')
      this.wsDomain = this.wsDomain.toLowerCase()
    },
    async setRequestWs() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      if (!this.$refs.requestWsForm.validate()) return false

      try {
        this.isCheckingWsDomain = true
        let result = await chkWsDomain(this, this.wsDomain)

        if (result.body.wsInfo)
          this.$router.push({ name: 'RequestWorkspace', params: { passedWsInfo: result.body.wsInfo } }).catch(() => {})
        else throw new Error('workspaceNotExist')
      } catch (error) {
        this.errorCode = typeof error.response !== 'undefined' ? error.response.data : error.message

        if (this.errorCode === 'workspaceNotExist') this.errorMessage = this.$t('msgCheckWorkspaceDomain')
        else this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))

        console.log(this.errorCode, this.errorMessage)

        this.showMsg = true
      } finally {
        this.isCheckingWsDomain = false
        this.isLoading = false
      }
    },
  },
}
</script>
